/* Snoobipaws theme interactions */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Mobile menu ---- */
    var burger = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (burger && menu) {
      burger.addEventListener('click', function () {
        menu.classList.toggle('open');
      });
    }

    /* ---- Flavor chips ---- */
    document.querySelectorAll('[data-flavor-group]').forEach(function (group) {
      var label = group.querySelector('[data-flavor-current]');
      group.querySelectorAll('[data-flavor]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          group.querySelectorAll('[data-flavor]').forEach(function (c) { c.classList.remove('active'); });
          chip.classList.add('active');
          if (label) label.textContent = chip.getAttribute('data-flavor');
          var input = document.querySelector('[data-variant-input]');
          if (input) input.value = chip.getAttribute('data-variant-id') || input.value;
        });
      });
    });

    /* ---- Gallery thumbnails ---- */
    var main = document.querySelector('[data-gallery-main]');
    var hero = document.querySelector('[data-gallery-hero]');
    var alt = document.querySelector('[data-gallery-alt]');
    var altLabel = document.querySelector('[data-gallery-alt-label]');
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var isHero = thumb.getAttribute('data-thumb') === '0';
        if (hero) hero.style.display = isHero ? '' : 'none';
        if (alt) alt.style.display = isHero ? 'none' : 'flex';
        if (altLabel) altLabel.textContent = thumb.getAttribute('data-label') || '';
      });
    });

    /* ---- Accordions (generic) ---- */
    document.querySelectorAll('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.parentElement.querySelector('[data-acc-body]');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (body) body.hidden = open;
        var sign = btn.querySelector('[data-acc-sign]');
        if (sign) sign.textContent = open ? '+' : '\u2212';
      });
    });

    /* ---- Add to cart helpers (native product form submits) ---- */
    document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      /* native submit handled by the product form; nothing needed here */
    });
  });
})();
